import React from 'react'
import { css } from 'aphrodite'
import { Col, Row } from 'reactstrap'

import style from '../style'

export const PartnerBox = props => (
  <Row>
    <Col md='2'>
      <img
        src={props.image.url}
        alt={props.image.alt}
        className={css(style.partner.image)}
      />
    </Col>
    <Col md='10'>
      <Row>
        <Col>
          <h3 className={css(style.partner.title)}>{props.title}</h3>
        </Col>
      </Row>
      <Row>
        <Col xs='auto'>
          <div className={css(style.partner.infoBox)}>
            <span className={css(style.partner.infoLabel)}>
              <i className={`fa fa-globe text-success`} />
            </span>
            <a
              className={`text-success ${css(style.partner.infoValue)}`}
              target={`_blank`}
              href={props.link.url}
            >
              {props.link.title}
            </a>
          </div>
        </Col>
        <Col xs='auto'>
          <div className={css(style.partner.infoBox)}>
            <span className={css(style.partner.infoLabel)}>
              <i className={`fa fa-server`} />
            </span>
            <span className={css(style.partner.infoValue)}>
              {props.category}
            </span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <p
            className={css(style.partner.p)}
            dangerouslySetInnerHTML={{
              __html: props.description.replace(/(?:\r\n|\r|\n)/g, '<br />')
            }}
          />
        </Col>
      </Row>
    </Col>
  </Row>
)

export default PartnerBox



// WEBPACK FOOTER //
// ./src/components/Partnets/partials/PartnerBox.js